// @ts-nocheck
/* eslint-disable */
import { getMelownCard } from "./card";

export default class Melown3dMarker {
	/**
	 * Marker ve 3d - nozicka s koleckem a moznosti ikony.
	 *
	 * @param  {Number} x Pozice na ose
	 * @param  {Number} y Pozice na ose
	 * @param  {Object} [opts] Volitelna konfigurace
	 * @param  {Object} [texture] Volitelna textura
	 * @param  {Object} [lineStyle] Volitelny styl cary
	 */
	constructor(x, y, opts = {}, texture = {}, lineStyle = {}) {
		this._opts = Object.assign({
			cardIconSize: [26, 26],
			focusCardIconSize: [40, 40],
			removePointerCursor: false, // odstranit cursor:pointer
			depthOffset: [0, 0, 0], // volitelne pro vykresleni hlavni textury a nozky
			focusDepthOffsetInc: -0.1, // kolik pridat pri focusu u depth offsetu
			markersMinZoomFix: 17,
			markersMinZoomValue: -50
		}, opts);
		this._texture = Object.assign({
			src: "", // hlavni ikona
			text: "",
			font: "12px Arial",
			texture: "",
			active: null, // pozadi pro marker aktivni
			nonActive: null // neaktivni pozadi
		}, texture);
		this._lineStyle = Object.assign({
			width: 2,
			height: 25,
			focusHeight: 40,
			activeColor: [204, 0, 0, 255],
			color: [121, 121, 121, 255]
		}, lineStyle);
		this._presenter = null;
		this._melownCore = null;
		this._position = {
			x: x,
			y: y
		};
		this._loaded = false;
		this._textures = {};
		this._layer = null;
		this._callbacks = {
			click: null,
			mouseEnter: null,
			mouseLeave: null
		};
		this._visible = false;
		this._bottomCoords = null;
		this._topCoords = null;
		this._poi = null;
		this._id = Math.random();
		this._plainId = null;
		this._card = {
			timeout: 500,
			id: null,
			opened: false,
			el: null,
			visit: null,
			size: null,
			defaultSize: [312, 95]
		};
		this._isDetail = false;
		this._active = true;
		this._focus = false;
		this._alwaysVisible = false;
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._closeCard();
		this._presenter = null;
		this._melownCore = null;
	}

	/**
	 * Je marker viditelny?
	 *
	 * @return  {Boolean}
	 */
	get visible() {
		return this._visible;
	}

	/**
	 * Nastaveni vlastnika - kdyz si vrstva do sebe pripne marker.
	 *
	 * @param {Melown3dLayer} layer Vrstva
	 * @param {Melown3d} presenter Instance presenteru
	 * @param {Object} melownCore Object z melown
	 */
	setOwner(layer, presenter, melownCore) {
		this._layer = layer;
		this._presenter = presenter;
		this._melownCore = melownCore;

		this._init();
	}

	/**
	 * Nastaveni aktivnosti markeru. Pokud je false, pouzije se pruhlednost dane konstantou.
	 *
	 * @param {Boolean} [state = true]
	 */
	setActive(state) {
		this._active = state;
	}

	/**
	 * Focus znacky - znacka vyroste o 50%, zvetsi se ji horni kolecko.
	 *
	 * @param {Boolean} [state = false]
	 */
	setFocus(state) {
		this._focus = state;
	}

	/**
	 * Nastaveni POI dat.
	 *
	 * @param {Object} poi POI data
	 */
	setPOI(poi) {
		this._poi = poi;
	}

	/**
	 * Nastaveni souradnic, pak prekresleni na nove pozici.
	 *
	 * @param {Number} x Nove souradnice X
	 * @param {Number} y Nove souradnice Y
	 */
	setCoords(x, y) {
		this._position.x = x || 0;
		this._position.y = y || 0;

		if (typeof x === "number" && typeof y === "number") {
			this.redraw();
		}
	}

	/**
	 * Je marker vzdycky viditelny?
	 *
	 * @param {Boolean} state Stav
	 */
	setAlwaysVisible(state) {
		this._alwaysVisible = state;
	}

	/**
	 * Prekresleni markeru - markery drzi vrstva, ktera je vykresluje, proto se tato metoda zavola na ni.
	 */
	redraw() {
		if (this._layer) {
			this._layer.redraw();
		}
	}

	/**
	 * Vykresleni markeru - pre render - pokud potrebujeme neco vykreslit nejdrive.
	 *
	 * @param {Function} render - hlavni renderovaci objekt melownu
	 */
	preRender(render, pos) {
		if (!this._loaded) return;

		let lineStyle = this._getLineStyle(pos);

		if (lineStyle) {
			render.drawLineString(lineStyle);
		}
	}

	/**
	 * Vykresleni markeru - hlavni faze.
	 *
	 * @param {Function} render - hlavni renderovaci objekt melownu
	 */
	render(render, pos) {
		if (!this._loaded) return;

		// vzdycky mame alespon active texturu
		let texture = this._active ? this._textures.active : (this._textures.nonActive || this._textures.active);
		let rect = this._getRenderRect(texture);
		let depthOffset = this._opts.depthOffset.slice();

		if (pos.mercZ >= this._opts.markersMinZoomFix) {
			depthOffset[0] = this._opts.markersMinZoomValue;
		}

		if (this._focus) {
			depthOffset[0] += this._opts.focusDepthOffsetInc;
		}

		render.drawImage({
			rect,
			texture: texture.texture,
			depth: this._topCoords[2],
			blend: true,
			depthTest : true,
			writeDepth: true,
			depthOffset
		});
	}

	/**
	 * Bind kliknuti na znacku.
	 *
	 * @param  {Function} cb Volana funkce
	 * @param  {Object}   scope Scope funkce
	 */
	onClick(cb, scope) {
		this._callbacks.click = {
			cb: cb,
			scope: scope
		};
	}

	/**
	 * Bind vstupu mysi na znacku.
	 *
	 * @param  {Function} cb Volana funkce
	 * @param  {Object}   scope Scope funkce
	 */
	onMouseEnter(cb, scope) {
		this._callbacks.mouseEnter = {
			cb: cb,
			scope: scope
		};
	}

	/**
	 * Bind opusteni mysi, kdyz byla na znacce.
	 *
	 * @param  {Function} cb Volana funkce
	 * @param  {Object}   scope Scope funkce
	 */
	onMouseLeave(cb, scope) {
		this._callbacks.mouseLeave = {
			cb: cb,
			scope: scope
		};
	}

	/**
	 * Klinuti na marker - vola vrstva.
	 */
	click() {
		this._clearCardTimeout();

		let data = this._callbacks.click;

		if (data && typeof data.cb === "function") {
			return data.cb.apply(data.scope || data.cb || []);
		}
		else {
			return null;
		}
	}

	/**
	 * Vstup mysi na marker - vola vrstva.
	 */
	mouseEnter() {
		let data = this._callbacks.mouseEnter;

		if (data && typeof data.cb === "function") {
			return data.cb.apply(data.scope || data.cb || []);
		}
		else {
			return null;
		}
	}

	/**
	 * Mys opustila znacku - vola vrstva.
	 */
	mouseLeave() {
		let data = this._callbacks.mouseLeave;

		if (data && typeof data.cb === "function") {
			return data.cb.apply(data.scope || data.cb || []);
		}
		else {
			return null;
		}
	}

	/**
	 * Mys zustava stale na znacce - vola vrstva. Neco jak mouseover.
	 */
	stillEnter() {
		if (this._opts.removePointerCursor) {
			if (this._layer) {
				this._layer.removePointerCursor();
			}
		}
	}

	/**
	 * Kalkulace viditelnosti znacky. Spocita souradnice, pokud neni spocitana vyska, tak spocita i ji.
	 * Vraci viditelnost markeru. Vstupem je sirka a vyska viewportu.
	 *
	 * @param  {Number} width Sirka viewportu
	 * @param  {Number} height Vyska viewportu
	 * @param  {Melown3dPos} pos Aktualni pozice
	 * @return {Boolean}
	 */
	calc(width, height, pos) {
		this._visible = false;

		// kalkulace pred vykreslenim
		if (this._melownCore && this._loaded && typeof this._position.x == "number" && typeof this._position.y == "number") {
			let physCoords = this._melownCore.map.convertCoordsFromNavToPhys([this._position.x, this._position.y, 0], 'float', null, false);
			let canvasCoords = this._melownCore.map.convertCoordsFromPhysToCanvas(physCoords);

			if (canvasCoords[2] <= 1.0) {
				let markerHeight = this._focus && this._texture.src ? this._lineStyle.focusHeight : this._lineStyle.height;
				let opts = this._presenter.options;
				let pitchDiff = Math.abs((opts.maxPitch - pos.pitch) / (opts.maxPitch - opts.minPitch));
				markerHeight *= Math.max(pitchDiff, 0.1); // min dame 0.1

				this._bottomCoords = canvasCoords;
				this._topCoords = [this._bottomCoords[0], this._bottomCoords[1] - markerHeight, this._bottomCoords[2]];
				this._visible = true;
			}
		}

		return this._visible;
	}

	/**
	 * Znacka se skryje, muzeme zakazat prekresleni.
	 *
	 * @param {Boolean} [noRedraw = false] Zakazani prekresleni
	 */
	hide(noRedraw) {
		this._visible = false;

		if (!noRedraw) {
			this.redraw();
		}
	}

	/**
	 * Ziskani hlouby horniho kolecka - pro trideni.
	 *
	 * @return {Number|Null}
	 */
	getDepth() {
		if (this._topCoords) {
			return this._topCoords[2];
		}
		else {
			return null;
		}
	}

	/**
	 * Ziskani bboxu markeru.
	 *
	 * @return {Object} lb, rt (left bottom, right top), souradnice x, y, vyska a sirka
	 */
	getBBox() {
		if (this._topCoords && this._loaded) {
			let rect = this._getRenderRect();
			let lbx = rect[0];
			let lby = rect[1];
			let rtx = rect[0] + rect[2];
			let rty = rect[1] + rect[3];

			return {
				lbx,
				lby,
				rtx,
				rty,
				width: rect[2],
				height: rect[3]
			};
		}
		else {
			return null;
		}
	}

	/**
	 * Ziskani pozice markeru - WGS84.
	 *
	 * @return {Object} klice x, y, z
	 */
	getPosition() {
		return this._position;
	}

	/**
	 * Je marker vzdy viditelny? Teda pokud je videt ve viewportu -> nechceme jej treba redit.
	 *
	 * @return {Boolean}
	 */
	getAlwaysVisible() {
		return this._alwaysVisible;
	}

	/**
	 * Nastal prunik markeru na souradnicich?
	 *
	 * @param  {Number}  x Souradnice X
	 * @param  {Number}  y Souradnice Y
	 * @return {Boolean}
	 */
	isIntersection(x, y) {
		let bbox = this.getBBox();

		return (bbox && x >= bbox.lbx && x <= bbox.rtx && y >= bbox.lby && y <= bbox.rty);
	}

	/**
	 * Bind karty - ma se na mouse enter objevit popup? Data se nastavuji v setPOI.
	 *
	 * @param  {Boolean} [isDetail = false] Jedna se o detail?
	 */
	bindCard(isDetail) {
		this._callbacks.mouseEnter = {
			cb: this._mouseEnter,
			scope: this
		};

		this._callbacks.mouseLeave = {
			cb: this._mouseLeave,
			scope: this
		};

		this._isDetail = isDetail;
	}

	/**
	 * Ziskani ID markeru.
	 *
	 * @return {Number}
	 */
	getId() {
		return this._id;
	}

	/**
	 * Ziskani zdroje markeru.
	 *
	 * @return {String}
	 */
	getSource() {
		return (this._poi ? this._poi.source : "no-source");
	}

	/**
	 * Ziskani ID z POI dat.
	 *
	 * @return {Number}
	 */
	getPlainId() {
		if (this._poi) {
			return this._poi.id;
		}
		else {
			if (this._plainId === null) {
				this._plainId = Math.round(Math.random(1000) * 1000);
			}

			return this._plainId;
		}
	}

	/**
	 * Klik na popup a znacku.
	 *
	 * @param  {Event} e
	 */
	handleEvent(e) {
		if (e.type == "click") {
			if (e.target.classList.contains("marker-card") || e.target.classList.contains("poi-icon")) {
				this.click();
				this._closeCard();
			}
		}
	}

	/**
	 * Ziskani vysky markeru - neni to position.z!
	 *
	 * @return {Number}
	 */
	getHeight() {
		return this._position.height;
	}

	/**
	 * Nastaveni novych hodnot markeru.
	 *
	 * @param   {Object}  opts Nove nastaveni
	 * @param   {Object}  texture Nove nastaveni textur
	 * @param   {Object}  lineStyle Nove nastaveni stylu cary
	 */
	update(opts = {}, texture = {}, lineStyle = {}) {
		Object.assign(this._opts, opts);
		Object.assign(this._texture, texture);
		Object.assign(this._lineStyle, lineStyle);

		this._loaded = false;

		this._init();
	}

	/**
	 * Init markeru - nacteni textur.
	 */
	_init() {
		if (this._presenter && !this._loaded) {
			this._textures.active = null;
			this._textures.nonActive = null;

			let allProm = [];

			// textura pro aktivni zobrazeni - vetsinu casu jde videt
			if (this._texture.active) {
				allProm.push(this._presenter.texture.get(this._texture.active.name, this._texture).then(data => {
					this._textures.active = data;
				}, e => {}));
			}

			// volitelne pro stav - kdy neni marker aktivni
			if (this._texture.nonActive) {
				allProm.push(this._presenter.texture.get(this._texture.nonActive.name, this._texture).then(data => {
					this._textures.nonActive = data;
				}, e => {}));
			}

			if (allProm.length) {
				Promise.all(allProm).then(() => {
					this._loaded = true;
					this.redraw();
				}, e => {});
			}
		}
	}

	/**
	 * Tato funkce se pouzije v pripade toho, ze se nabinduje popup.
	 * Vjteti mysi na znacku.
	 */
	_mouseEnter() {
		this._clearCardTimeout();

		this._card.id = setTimeout(() => {
			this._card.id = null;
			this._openCard();
		}, this._card.timeout);
	}

	/**
	 * Tato funkce se pouzije v pripade toho, ze se nabinduje popup.
	 * Vjteti mysi mimo znacku.
	 */
	_mouseLeave() {
		this._clearCardTimeout();
		this._closeCard();
	}

	/**
	 * Vycisteni timeoutu pro zobrazeni vizitky.
	 */
	_clearCardTimeout() {
		if (this._card.id) {
			clearTimeout(this._card.id);
			this._card.id = null;
		}
	}

	/**
	 * Otevreni vizitky.
	 */
	_openCard() {
		// chceme poie, ale ne fotky
		if (this._card.opened || !this._presenter || !this._poi || (this._poi && this._poi.source == "foto")) return;

		if (!this._card.el) {
			let cardCover = document.createElement("div");
			cardCover.classList.add("smap");
			cardCover.classList.add("marker-card");
			cardCover.addEventListener("click", this);

			let cardObj = this._getCard();
			cardObj.promise.then(() => {
				this._positionCard();
			}, e => {});

			this._card.el = cardCover;
			this._card.visit = cardObj.el;

			cardCover.appendChild(this._card.visit);

			let iconHolder = document.createElement("div");
			iconHolder.classList.add("poi-icon");
			iconHolder.style.backgroundImage = "url({0})".replace("{0}", this._texture.src);
			iconHolder.style.width = this._opts.cardIconSize[0] + "px";
			iconHolder.style.height = this._opts.cardIconSize[1] + "px";
			cardCover.appendChild(iconHolder);
		}

		// pozice + 2 je vyrovnani na marker medium
		let rect = this._getRenderRect();

		this._card.el.style.left = (rect[0] + 2) + "px";
		this._card.el.style.top = (rect[1] + 2) + "px";
		this._card.opened = true;

		this._presenter.addCard(this._card.el);
		this._positionCard();
	}

	/**
	 * Ziskani obsahu vizitky.
	 *
	 * @return {Object} el a promise
	 */
	_getCard() {
		let el = document.createElement("div");
		el.classList.add("card");
		el.classList.add("marker-popup");

		let header = document.createElement("div");
		header.classList.add("card-header");

		let body = document.createElement("div");
		body.classList.add("card-body");

		let footer = document.createElement("div");
		footer.classList.add("card-footer");

		let tail = document.createElement("div");
		tail.classList.add("tail");

		el.appendChild(header);
		el.appendChild(body);
		el.appendChild(footer);
		el.appendChild(tail);

		let cardObj = getMelownCard().bindCard(body, this._poi, this._isDetail);
		cardObj.removeCardCb = () => {
			this._closeCard();
			this._presenter.redraw();
		};

		return {
			el: el,
			promise: cardObj.promise
		};
	}

	/**
	 * Zavreni vizitky.
	 */
	_closeCard() {
		if (!this._card.opened || !this._presenter) return;

		this._card.opened = false;
		this._clearCardTimeout();
		this._presenter.removeCard();
	}

	/**
	 * Spocitani rozmeru karty pro jeji polohu.
	 */
	_countCardSize() {
		if (this._card.visit && this._card.el.parentNode) {
			this._card.size = [this._card.visit.offsetWidth, this._card.visit.offsetHeight];
		}
	}

	/**
	 * Napozicovani karty v zavilosti na jejich rozmerech.
	 */
	_positionCard() {
		this._countCardSize();

		let size = this._focus && this._texture.src ? this._opts.focusCardIconSize : this._opts.cardIconSize;
		let halfWidth = Math.round(size[0] / 2);
		let quaterHeight = Math.round(size[1] / 4);
		let cardSize = this._card.size || this._card.defaultSize;

		this._card.visit.style.left = -(Math.round(cardSize[0] / 2) - halfWidth) + "px";
		this._card.visit.style.top = -(cardSize[1] - quaterHeight) + "px";
	}

	/**
	 * Podpurna funkce pro vrstvu - ziskani stylu vykresleni nozky markeru.
	 *
	 * @return {Object}
	 */
	_getLineStyle(pos) {
		let color = this._active ? this._lineStyle.activeColor : this._lineStyle.color;

		if (this._bottomCoords && this._topCoords && color) {
			let depthOffset = this._opts.depthOffset.slice();

			if (pos.mercZ >= this._opts.markersMinZoomFix) {
				depthOffset[0] = this._opts.markersMinZoomValue;
			}

			if (this._focus) {
				depthOffset[0] += this._opts.focusDepthOffsetInc;
			}

			return {
				points : [this._bottomCoords, this._topCoords],
				color: color.slice(), // musi byt kopie, jinak se to vykresli blbe
				width: this._lineStyle.width,
				depthTest : true,
				writeDepth: true,
				depth: this._topCoords[2],
				blend: color[2] != 255,
				depthOffset
			};
		}
		else {
			return null;
		}
	}

	/**
	 * Ziskani rozmeru pro vykresleni markeru.
	 *
	 * @param   {Object}  [texture] Volitelna vlastni textura
	 * @return  {Array} [x,y,width,height]
	 */
	_getRenderRect(texture) {
		texture = texture || this._textures.active || this._textures.nonActive;
		let topCoords = this._topCoords || [0, 0];

		return [
			topCoords[0] - texture.anchorLeft,
			topCoords[1] - texture.anchorTop + 2, // 2 - at jde cara trochu vic do markeru
			texture.width,
			texture.height
		];
	}
}
